<div class="dialog">
    <p mat-dialog-title>{{data.text | translate}}</p>
    <div mat-dialog-content>
        <button mat-flat-button [mat-dialog-close]="false" class="cancel-button"
                *ngIf="data.cancel">{{'Cancel' | translate}} </button>
        <button [mat-dialog-close]="true" class="ok-button" color="warn" mat-flat-button>{{'Ok' | translate}}</button>
    </div>
</div>
